import createReactComponent from '../createReactComponent';
export default createReactComponent('chevrons-up-down', 'ChevronsUpDown', [["path",{"d":"m8 16 4 4 4-4M8 8l4-4 4 4","key":"svg-0"}]]);